// src/graphql/mutations/engagementMutations.js
// Engagement campaigns: send to a selection, execute the sunset pause
import { engagementRecipientFields } from '../queries/engagementQueries';

export const sendEngagementMail = () => `mutation SendEngagementMail($input: SendEngagementMailInput!) {
    adminSendEngagementMail(input: $input) {
        success
        error
        sent {${engagementRecipientFields}
        }
        skipped {${engagementRecipientFields}
        }
    }
}`;

export const applyEngagementSunset = () => `mutation ApplyEngagementSunset($dryRun: Boolean) {
    adminApplyEngagementSunset(dryRun: $dryRun) { success error paused }
}`;
